import { render, staticRenderFns } from "./TopUpList.vue?vue&type=template&id=5c6f1a27&scoped=true"
import script from "./TopUpList.vue?vue&type=script&lang=js"
export * from "./TopUpList.vue?vue&type=script&lang=js"
import style0 from "./TopUpList.vue?vue&type=style&index=0&id=5c6f1a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f1a27",
  null
  
)

export default component.exports